import { Component, Input, OnInit } from '@angular/core';
import { Applicant } from '@app/models/recruiting/applicant.model';
import { NotifyService } from '@app/services';
import { JobFunnelNameOptions } from '@app/types/translatables/applicant-tracker/job-funnel-name.options';
import { Employee } from '@models/employee/employee.model';

@Component({
    selector: 'app-job-postings-card',
    templateUrl: './job-postings-card.template.html',
    styleUrls: ['./job-posting-card.style.scss'],
})
export class JobPostingsCardComponent implements OnInit {
    @Input() applicant: Applicant;

    isLoading = true;

    isOtherJobOpportunitiesExpanded = false;

    applicants: Applicant[] = [];

    managerAssignmentsEmployees: Employee[] = [];

    jobFunnelDisplay = JobFunnelNameOptions;

    constructor(private notify: NotifyService) {}

    async ngOnInit(): Promise<void> {
        try {
            // We have old applicants in the DB without email address.
            if (!this.applicant.email) {
                this.isLoading = false;
                return;
            }

            const [applicants] = await Applicant.with(['jobPosting', 'jobFunnel'])
                .where('email', this.applicant.email)
                .all();
            this.applicants = applicants.filter((applicant: Applicant) => applicant.id !== this.applicant.id);

            this.managerAssignmentsEmployees = this.applicant.jobPosting.managerAssignments.map(
                (managerAssignment) => managerAssignment.employee
            );
        } catch (err) {
            this.notify.error(err);
        }

        this.isLoading = false;
    }
}
